import { render, staticRenderFns } from "./OrderPanel.vue?vue&type=template&id=6f134bd8&scoped=true"
import script from "./OrderPanel.vue?vue&type=script&lang=js"
export * from "./OrderPanel.vue?vue&type=script&lang=js"
import style0 from "./OrderPanel.vue?vue&type=style&index=0&id=6f134bd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f134bd8",
  null
  
)

export default component.exports